import { createSelector } from '@ngrx/store';
import { AppState } from '../../../core/models/appState.model';
// approve.selectors.ts

export const ApproveStatusResponse = createSelector(
  (state: AppState) => state.approve.status,
  (status: string) => status
);
